import React, {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import {Outlet} from "react-router-dom";
import {IconButton, Typography, Toolbar, CircularProgress, Backdrop, Stack, Box, AppBar, Badge} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

import '../css/App.css';

import {useCurrentUser} from "../hooks/useCurrentUser";
import {useShiftUpdateCount} from "../hooks/useShiftUpdateCount";
import {usePermissions} from "../hooks/usePermissions";

import NavigationDrawer from "../components/NavigationDrawer";
import TimezoneOption from "../components/common/TimezoneOption";
import CurrentTimeDisplay from "../components/common/CurrentTimeDisplay";

import GetHeaderFromPath from "../helpers/GetHeaderFromPath";

export default function RootView({onLogoutClicked}) {

    const {currentUser, loading} = useCurrentUser();
    const location = useLocation();
    const permissions = usePermissions(currentUser);

    const [drawerOpen, setDrawerOpen] = useState(false);
    const [title, setTitle] = useState();

    const {updatedShiftCount} = useShiftUpdateCount();

    useEffect(() => {
        setTitle(GetHeaderFromPath(location?.pathname));
    }, [location])

    function toggleDrawer(event, state) {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setDrawerOpen(state);
    }

    return (
            <Box>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={loading}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>

                <Box sx={{flexGrow: 1}}>
                <AppBar position="static">
                    <Toolbar sx={{height: '4rem', minHeight: '4rem'}}>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={(e) => toggleDrawer(e, true)}
                            edge="start"
                            sx={{
                                marginRight: 5,
                            }}>
                            <Badge badgeContent={updatedShiftCount} color="error" overlap="circular">
                                <MenuIcon/>
                            </Badge>
                        </IconButton>
                        <Box sx={{display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center"}}>
                            <Typography variant="h6" noWrap component="div">
                                VE Back Office - {title}
                            </Typography>
                            {(permissions.canTrafficManage || permissions.canContentManage || permissions.canAdmin || permissions.canQA)
                                &&
                                <>
                                    <Stack direction="column" alignSelf={"justify"}>
                                        <CurrentTimeDisplay />
                                        <TimezoneOption />
                                    </Stack>
                                </>
                            }
                        </Box>
                    </Toolbar>
                </AppBar>
                </Box>
            <NavigationDrawer
                open={drawerOpen}
                onClose={(e) => toggleDrawer(e, false)}
                currentUser={currentUser}
                onLogoutClicked={onLogoutClicked}
                updatedShiftCount={updatedShiftCount}
                permissions={permissions}
            />
                <Box component="main" sx={{py: 1}}>
                    <Outlet/>
                </Box>
            </Box>
    );
}